<div [formGroup]="parentForm" *ngIf="isLinkEnabled" class="link-container">
    <sdps-icon *ngIf="isText1$ | async" color="active" type="functional" name="plus" size="medium" class="plus-minus-icon" (click)="changeAlternateTextState()"></sdps-icon> 
    <a *ngIf="isText1$ | async" class="link-text" id="alternateTextLink1" [attr.data-testid]="alternatingTextLinkControlModel.controlName + '-alternating-text-link-1'" 
        (click)="changeAlternateTextState()">
        {{ alternatingTextLinkControlModel.text1.key }}
    </a>
    <sdps-icon *ngIf="!(isText1$ | async)" color="active" type="functional" name="minus" size="medium" class="plus-minus-icon" (click)="changeAlternateTextState()"></sdps-icon> 
    <a *ngIf="!(isText1$ | async)" class="link-text" id="alternateTextLink2" [attr.data-testid]="alternatingTextLinkControlModel.controlName + '-alternating-text-link-2'"  
        (click)="changeAlternateTextState()">
        {{ alternatingTextLinkControlModel.text2.key }}
    </a>
    <mm-tooltip [position]="alternatingTextLinkControlModel.tooltip?.position || 'right'" [containsLink]="alternatingTextLinkControlModel.tooltip?.containsLink || false" id="alternate-text-tooltip">
        <tooltip-content>
        <div>{{ alternatingTextLinkControlModel.tooltip?.content }}</div>
        </tooltip-content>
        <tooltip-trigger-element>
        <sdps-icon color="active" type="functional" name="info" size="small"></sdps-icon>
        </tooltip-trigger-element>
    </mm-tooltip>
</div>